import TasksTemplate from '../../../components/Templates/Tasks/TasksTemplate';
/**
 * @page Task.tsx
 * @description Management module to assign a Task.
 * @return { page }
 */
function Tasks() {
  return <TasksTemplate />;
}

export default Tasks;
